import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';
export function AboutCollab() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-18">
      <div className="absolute top-0 left-0 w-64 h-64 bg-rainforest/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-19" />
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-turquoise/5 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-20" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-21">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl font-heading font-bold text-ocean-dark mb-8 leading-tight" data-id="element-22">
          {t.aboutCollab.headline}
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-lg md:text-xl text-gray-600 leading-relaxed" data-id="element-23">
          {t.aboutCollab.description}
        </motion.p>
      </div>
    </section>;
}